<div class="veld clickable">
  <div class="iconContainer">
    <i [class]="verplichtCheckboxStyle(viewModel.onGetVeld | async)" (click)="onVerplichtClicked()"></i>
  </div>
  <p class="bodyContent veldnaam" (click)="onVerplichtClicked()">{{(viewModel.onGetVeld | async)?.naam}}</p>
</div>
